export default class Disruption {
  constructor(payload) {
    this.id = payload.id;
    this.type = payload.type;
    this.line = payload.line;
    this.isMessageHidden = payload.isMessageHidden;
    this.direction = payload.direction;
    this.lineStatus = payload.lineStatus;
    this.fromStation = payload.fromStation;
    this.toStation = payload.toStation;
    this.affectedStations = payload.affectedStations;
    this.delayMinutes = payload.delayMinutes;
    this.resumeAt = payload.resumeAt;
    this.createdAt = payload.createdAt;
    this.isAffectingAllStation = payload.isAffectingAllStation;
  }
}
